import { render, staticRenderFns } from "./keyValueComponent.vue?vue&type=template&id=4a946144&"
import script from "./keyValueComponent.vue?vue&type=script&lang=js&"
export * from "./keyValueComponent.vue?vue&type=script&lang=js&"
import style0 from "./keyValueComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports